module.exports = __webpack_public_path__ + "static/Rackspace-12d10e7e8956b0173cff4436ddd45a7b.svg";